import { createSlice } from '@reduxjs/toolkit';

import { DillDispute } from '@dill/dill-shared';
import {
  getSupplierDisputesExtraReducer,
  getSupplierOpenDisputesCountExtraReducer,
  updateDisputeExtraReducer,
  createDisputeExtraReducer,
} from '../reducers/disputesReducers';

export interface DisputesInitialState {
  loadingList: string[];
  error: string | null;
  disputes: DillDispute[];
  supplierOpenDisputesCount: number;
}

const initialState: DisputesInitialState = {
  loadingList: [],
  error: null,
  disputes: [],
  supplierOpenDisputesCount: 0,
};

export const disputesSlice = createSlice({
  name: 'disputes',
  initialState,
  reducers: {
    resetDisputesRootState: () => initialState,
  },
  extraReducers(builder) {
    getSupplierDisputesExtraReducer(builder);
    updateDisputeExtraReducer(builder);
    getSupplierOpenDisputesCountExtraReducer(builder);
    createDisputeExtraReducer(builder);
  },
});

export const { resetDisputesRootState } = disputesSlice.actions;
